import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { SidebarProvider, useSidebar } from '../../contexts/SidebarContext';
import { Button } from '../ui';
import { cn } from '@/lib/utils';

function DashboardLayoutContent() {
  const { isCollapsed, toggle } = useSidebar();

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />

      <div
        className={cn(
          'flex flex-col min-h-screen transition-all duration-300',
          isCollapsed ? 'lg:ml-14' : 'lg:ml-52'
        )}
      >
        {/* Mobile header - only shows menu button */}
        <div className="sticky top-0 z-20 flex h-12 items-center border-b bg-background px-3 lg:hidden">
          <Button
            variant="ghost"
            size="icon"
            onClick={toggle}
            aria-label="Abrir menu"
            className="h-8 w-8"
          >
            <Menu className="h-4 w-4" />
          </Button>
        </div>

        <main className="flex-1 p-3 lg:p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export function DashboardLayout() {
  return (
    <SidebarProvider>
      <DashboardLayoutContent />
    </SidebarProvider>
  );
}
